import api from '@/services/api.js';
let host = window.location.hostname;
let domain = `https://localhost.com:8443`;
if (host.toLowerCase().includes('jaekjay')) {
	domain = `https://mtlcargo.jaekjay.com`;
}
if (host.toLowerCase().includes('mtlcargo.net')) {
	domain = `https://mtlcargo.net`;
}
function getHeaders() {
	let headers = {};
	headers.Authorization = `bearer ${localStorage.getItem('token')}`;
	return headers;
}
export default {
	addContactUs(contactUsInfo) {
		let url = domain + '/api/contactus/add';
		return api.post(url, contactUsInfo);
	},
	addCustomer(customer) {
		let url = domain + '/api/customer/add';
		return api.post(url, customer);
	},
	addDeliveryAddress(deliveryAddressInfo) {
		let url = domain + '/api/delivery/address/add';
		return api.post(url, deliveryAddressInfo);
	},
	addExpense(expenseInfo) {
		let url = domain + '/api/expense/add';
		return api.post(url, expenseInfo);
	},
	addExpenses(expenseInfos) {
		let url = domain + `/api/expense/add/list`;
		return api.post(url, expenseInfos);
	},
	addInvoice(invoice) {
		let url = domain + '/api/invoice/add';
		return api.post(url, invoice);
	},
	addProductPictureInfos(pictureInfos) {
		let url = domain + '/api/file/add/product/picture/infos';
		return api.post(url, pictureInfos);
	},
	addProduct(product) {
		let url = domain + '/api/product/add';
		return api.post(url, product);
	},
	addPayment(payment) {
		let url = domain + '/api/payment/add';
		return api.post(url, payment);
	},
	addStock(stockInfo) {
		let url = domain + '/api/stock/add';
		return api.post(url, stockInfo);
	},
	addStockGroup(stockGroup) {
		let url = domain + '/api/stock/add/group';
		return api.post(url, stockGroup);
	},
	addShipmentGroup(shipmentGroupInfo) {
		let url = domain + '/api/shipment/add/group';
		return api.post(url, shipmentGroupInfo);
	},
	addShipment(shipmentInfo) {
		let url = domain + '/api/shipment/add';
		return api.post(url, shipmentInfo);
	},
	addOrderToShipmentGroup(shipmentGroupOrderAssociationInfo) {
		let url = domain + '/api/order/add/to/shipment/group';
		return api.post(url, shipmentGroupOrderAssociationInfo);
	},
	addVendor(vendor) {
		let url = domain + '/api/vendor/add';
		return api.post(url, vendor);
	},
	deleteProductPictureById(id) {
		let url = domain + `/api/file/delete/product/picture/by/id/${id}`;
		return api.get(url);
	},
	deleteOrderById(id) {
		let url = domain + `/api/order/delete/by/id/${id}`;
		return api.get(url);
	},
	deleteDeliveryInfoById(id) {
		let url = domain + `/api/delivery/address/delete/by/id/${id}`;
		return api.get(url);
	},
	deleteStockById(id) {
		let url = domain + `/api/stock/delete/by/id/${id}`;
		return api.get(url);
	},
	deleteCustomerById(id) {
		let url = domain + `/api/customer/delete/by/id/${id}`;
		return api.get(url);
	},
	deleteExpenseById(id) {
		let url = domain + `/api/expense/delete/by/id/${id}`;
		return api.get(url);
	},
	generateProductReport(filters) {
		let url = domain + `/api/product/generate`;
		return api.post(url, filters);
	},
	generateOrderReportByGroupId(groupId) {
		let url =
			domain +
			`/api/shipment/generate/order/report/by/group/id/${groupId}`;
		return api.get(url);
	},
	generateReportByGroupId(groupId) {
		let url =
			domain + `/api/shipment/generate/report/by/group/id/${groupId}`;
		return api.get(url);
	},
	getCustomerById(id) {
		let url = domain + `/api/customer/get/by/id/${id}`;
		return api.get(url);
	},
	getCustomers() {
		let url = domain + `/api/customer/get`;
		return api.get(url);
	},
	getDropdowns() {
		let url = domain + `/api/dropdown/get`;
		return api.get(url);
	},
	updateDropdownOption(option) {
		let url = domain + `/api/dropdown/update/option`;
		return api.post(url, option);
	},
	getExpenseById(id) {
		let url = domain + `/api/expense/get/by/id/${id}`;
		return api.get(url);
	},
	getInvoiceById(id) {
		let url = domain + `/api/invoice/get/by/id/${id}`;
		return api.get(url);
	},
	getProductById(id) {
		let url = domain + `/api/product/get/by/id/${id}`;
		return api.get(url);
	},
	getProductsByStoreId(storeId, filter) {
		let url = domain + `/api/product/get/by/store/id/${storeId}`;
		return api.post(url, filter);
	},
	getProducts(filter) {
		let url = domain + `/api/product/get`;
		return api.post(url, filter);
	},
	getProductRankings(filter = null) {
		let url = domain + `/api/product/get/rankings`;
		return api.post(url, filter);
	},
	getPublicProducts(filter) {
		let url = domain + `/api/product/get/public`;
		return api.post(url, filter);
	},
	getShipments() {
		let url = domain + `/api/shipment/get`;
		return api.get(url);
	},
	getShipmentGroups() {
		let url = domain + `/api/shipment/get/groups`;
		return api.get(url);
	},
	getShipmentGroupById(id) {
		let url = domain + `/api/shipment/get/group/by/id/${id}`;
		return api.get(url);
	},
	getShipmentById(id) {
		let url = domain + `/api/shipment/get/by/id/${id}`;
		return api.get(url);
	},
	getShipmentByTracking(tracking) {
		let url = domain + `/api/shipment/get/by/tracking/${tracking}`;
		return api.get(url);
	},
	getUsers() {
		let url = domain + `/api/user/get/`;
		return api.get(url);
	},
	getVendors() {
		let url = domain + '/api/vendor/get';
		return api.get(url);
	},
	getVendorById(id) {
		let url = domain + `/api/vendor/get/by/id/${id}`;
		return api.get(url);
	},
	getProductTransactionsById(id) {
		let url = domain + `/api/product/get/transactions/by/id/${id}`;
		return api.get(url);
	},
	getPayments() {
		let url = domain + `/api/payment/get`;
		return api.get(url);
	},
	getTotalCredits() {
		let url = domain + `/api/payment/get/total/credits`;
		return api.get(url);
	},
	updateCustomer(customer) {
		let url = domain + '/api/customer/update';
		return api.post(url, customer);
	},
	updateExpense(expense) {
		let url = domain + '/api/expense/update';
		return api.post(url, expense);
	},
	updateExpenseBasic(expense) {
		let url = domain + '/api/expense/update/basic';
		return api.post(url, expense);
	},
	updatePaymentBasic(payment) {
		let url = domain + '/api/payment/update/basic';
		return api.post(url, payment);
	},
	updateOrder(wrappedOrders) {
		let url = domain + '/api/order/update';
		return api.post(url, wrappedOrders);
	},
	updateShipment(shipment) {
		let url = domain + '/api/shipment/update';
		return api.post(url, shipment);
	},
	updateShipmentGroup(shipmentGroup) {
		let url = domain + '/api/shipment/update/group';
		return api.post(url, shipmentGroup);
	},
	updateVendor(vendor) {
		let url = domain + '/api/vendor/update';
		return api.post(url, vendor);
	},
	uploadProductPictures(formData) {
		let url = domain + '/api/file/upload/product/pictures';
		let headers = getHeaders();
		//headers['Content-Type'] = 'multipart/form-data';
		return api.post(url, formData, {
			headers: headers,
		});
	},
	addDropdownOption(option) {
		let url = domain + '/api/dropdown/add/option';
		return api.post(url, option);
	},
	addOrder(wrappedOrder) {
		let url = domain + '/api/order/add';
		return api.post(url, wrappedOrder);
	},
	deleteProductById(id) {
		let url = domain + `/api/product/delete/by/id/${id}`;
		return api.get(url);
	},
	deleteInvoiceById(id) {
		let url = domain + `/api/invoice/delete/by/id/${id}`;
		return api.get(url);
	},
	deletePaymentById(id) {
		let url = domain + `/api/payment/delete/by/id/${id}`;
		return api.get(url);
	},
	deleteShipmentById(id) {
		let url = domain + `/api/shipment/delete/by/id/${id}`;
		return api.get(url);
	},
	deleteShipmentGroupById(id) {
		let url = domain + `/api/shipment/delete/group/by/id/${id}`;
		return api.get(url);
	},
	getDeliveryAddressesByUserId(userId) {
		let url = domain + `/api/delivery/address/get/by/user/id/${userId}`;
		return api.get(url);
	},
	getDropdownToOptions() {
		let url = domain + `/api/dropdown/get/to/options`;
		return api.get(url);
	},
	getExpenses(dateRange) {
		let url = domain + `/api/expense/get`;
		return api.post(url, dateRange);
	},
	getExpensesByVendorId(vendorId) {
		let url = domain + `/api/expense/get/by/vendor/id/${vendorId}`;
		return api.get(url);
	},
	getProductPictureUrlById(pictureId) {
		if (!pictureId || pictureId == 0) return '';
		let url = domain + `/product/picture/${pictureId}`;
		return url;
	},
	getProductPicturesByProductId(productId) {
		let url =
			domain +
			`/api/file/get/product/pictures/by/product/id/${productId}`;
		return api.get(url);
	},
	getInvoices(dateRange = null) {
		let url = domain + `/api/invoice/get`;
		return api.post(url, dateRange);
	},
	getProductsByCategoryId(categoryId) {
		let url = domain + `/api/product/get/by/category/id/${categoryId}`;
		return api.get(url);
	},
	getOrdersByStatus(status) {
		let url = domain + `/api/Get/Orders/${status}`;
		return api.get(url);
	},
	getMinimalOrders() {
		let url = domain + `/api/order/get/minimal`;
		return api.get(url);
	},
	getOrders() {
		let url = domain + `/api/order/get/`;
		return api.get(url);
	},
	getOrdersByCustomerId(customerId) {
		let url = domain + `/api/order/get/by/customer/id/${customerId}`;
		return api.get(url);
	},
	getOrderById(id) {
		let url = domain + `/api/order/get/by/id/${id}`;
		return api.get(url);
	},
	getStocksByProductId(productId) {
		let url = domain + `/api/stock/get/by/product/id/${productId}`;
		return api.get(url);
	},
	getStocksByVendorId(vendorId) {
		let url = domain + `/api/stock/get/by/vendor/id/${vendorId}`;
		return api.get(url);
	},
	getOrdersByProductId(productId) {
		let url = domain + `/api/order/get/by/product/id/${productId}`;
		return api.get(url);
	},
	getOrdersByShipmentGroupId(shipmentGroupId) {
		let url =
			domain + `/api/order/get/by/shipment/group/id/${shipmentGroupId}`;
		return api.get(url);
	},
	getStoreById(id) {
		let url = domain + `/api/store/get/by/id/${id}`;
		return api.get(url);
	},
	getStoresByUserId(userId) {
		let url = domain + `/api/store/get/by/user/id/${userId}`;
		return api.get(url);
	},
	getContactUsLst() {
		let url = domain + `/api/contactus/get/`;
		return api.get(url);
	},
	getShipmentStatusByTracking(tracking) {
		let url = domain + `/api/shipment/get/status/by/tracking/${tracking}`;
		return api.get(url);
	},
	getStocks() {
		let url = domain + `/api/stock/get`;
		return api.get(url);
	},
	updateShipmentStatusByGroupId(info) {
		let url = domain + `/api/shipment/update/status/by/group/id`;
		return api.post(url, info);
	},
	login(loginInfo) {
		let url = domain + `/api/user/login`;
		return api.post(url, loginInfo, { withCredentials: true });
	},
	logout() {
		let url = domain + `/api/user/logout`;
		return api.get(url, { withCredentials: true });
	},
	registerStore(store) {
		let url = domain + '/api/store/register';
		return api.post(url, store);
	},
	registerUser(user) {
		let url = domain + '/api/user/register';
		return api.post(url, user);
	},
	submitPayment(paymentInfo) {
		let url = domain + '/api/payment/add';
		return api.post(url, paymentInfo);
	},
	submitPayments(paymentInfos) {
		let url = domain + '/api/payment/add/list';
		return api.post(url, paymentInfos);
	},
	unholdOrder(id, warehouseId) {
		let url =
			domain + `/api/order/unhold?id=${id}&warehouseId=${warehouseId}`;
		return api.post(url, {});
	},
	updateInvoice(invoice) {
		let url = domain + '/api/invoice/update';
		return api.post(url, invoice);
	},
	updateProduct(product) {
		let url = domain + '/api/product/update';
		return api.post(url, product);
	},
	updateOrderStatus(id, order) {
		let url = domain + `/api/Update/Order/Status/${id}`;
		return api.post(url, order);
	},
	updateStock(stock) {
		let url = domain + `/api/stock/update`;
		return api.post(url, stock);
	},
	verifySession() {
		let url = domain + `/api/user/verify/session`;
		return api.get(url);
	},
	verifyAccount(id) {
		let url = domain + `/api/verify/account/${id}`;
		return api.get(url);
	},
};
